// Random int pro random nastavovani hodnot pod intervalem
export const getRandomInt = (min, max) => {
    return Math.round(Math.random() * (max - min) + min);
}

// Vykresleni zakulaceneho rohu a odriznuti obsahu bez popisku hodnot
export const chartAreaRound = {
    id: "chartAreaRound",
    beforeDraw(chart, _args, opts) {
        const {ctx, chartArea} = chart; if (!chartArea) return
        const {left, top, right, bottom} = chartArea
        ctx.save()
        pathRound(ctx, {left, top, right, bottom}, opts.radius)
        ctx.fillStyle = opts.backgroundColor ?? "#0b0f18"
        ctx.fill()
        ctx.restore()
    },
    beforeDatasetsDraw(chart, _args, opts) {
        const {ctx, chartArea} = chart; if (!chartArea) return
        const {left, top, right, bottom} = chartArea
        ctx.save()
        pathRound(ctx, {left: left+0.5, top: top+0.5, right: right-0.5, bottom: bottom-0.5}, opts.radius)
        ctx.clip()
    },
    afterDatasetsDraw(chart) {
        chart.ctx.restore()
    }
}

// Nastroje pro oriznuti
function pathRound(ctx, {left, top, right, bottom}, r = {tl:0,tr:0,br:0,bl:0}) {
    const tl=r.tl||0,tr=r.tr||0,br=r.br||0,bl=r.bl||0
    ctx.beginPath()
    ctx.moveTo(left+tl, top)
    ctx.lineTo(right-tr, top); ctx.quadraticCurveTo(right, top, right, top+tr)
    ctx.lineTo(right, bottom-br); ctx.quadraticCurveTo(right, bottom, right-br, bottom)
    ctx.lineTo(left+bl, bottom); ctx.quadraticCurveTo(left, bottom, left, bottom-bl)
    ctx.lineTo(left, top+tl); ctx.quadraticCurveTo(left, top, left+tl, top)
    ctx.closePath()
}

function normRadius(r) {
    if (typeof r === "number") return {tl:0,tr:0,br:0,bl:r}
    return {tl: r?.tl||0, tr: r?.tr||0, br: r?.br||0, bl: r?.bl||0}
}
function roundRectPath(ctx, {left, top, right, bottom}, {tl, tr, br, bl}) {
    ctx.beginPath()
    ctx.moveTo(left + tl, top)
    ctx.lineTo(right - tr, top)
    ctx.quadraticCurveTo(right, top, right, top + tr)
    ctx.lineTo(right, bottom - br)
    ctx.quadraticCurveTo(right, bottom, right - br, bottom)
    ctx.lineTo(left + bl, bottom)
    ctx.quadraticCurveTo(left, bottom, left, bottom - bl)
    ctx.lineTo(left, top + tl)
    ctx.quadraticCurveTo(left, top, left + tl, top)
    ctx.closePath()
}
// Nastroje pro oriznuti

export const R = (min, pref, max, ref = 1920, round = true) => (ctx) => {
    const w = ctx?.chart?.width ?? window.innerWidth;
    const v = pref * (w / ref);
    const c = Math.max(min, Math.min(max, v));
    return round ? Math.round(c) : c;
}

// Dynamicke skalovani bodu na grafu aby na velkych obrazovkach nezmizely
export const getPointRadius = (ctx) => {
    const i = ctx.dataIndex
    const arr = ctx.dataset.data

    if (i !== arr.length - 1) return 0;
    if (document.getElementById("root").offsetWidth < 500) return 3;
    if (document.getElementById("root").offsetWidth < 992) return 4;
    if (document.getElementById("root").offsetWidth < 1920) return 5;
    if (document.getElementById("root").offsetWidth < 2560) return 6;
    if (document.getElementById("root").offsetWidth < 3840) return 8;

    return 12;
}

// Dynamicke skalovani borderu bodu
export const getPointBorderWidth = (ctx) => {
    const i = ctx.dataIndex
    const arr = ctx.dataset.data

    if (i !== arr.length - 1) return 0;
    if (document.getElementById("root").offsetWidth < 500) return 3;
    if (document.getElementById("root").offsetWidth < 992) return 6;
    if (document.getElementById("root").offsetWidth < 1920) return 9;
    if (document.getElementById("root").offsetWidth < 2560) return 12;
    if (document.getElementById("root").offsetWidth < 3840) return 15;

    return 25;
}

export function getSum(value) {
    if (typeof value === "number") return value;
    if (typeof value === "object") {
        let sum = 0;
        for (let i = 0; i < value.length; i++) {
            sum += value[i];
        }
        return sum;
    }

    return 0;
}